import Vue from 'vue'
import Mixins from '@travelc/utilities/mixins'
import Loader from '@components/blocks/loader.vue'
import SentryInit from '@src/sentry'
import router from '@router/router'
import routes from '@travelc/routes'

// site specific components and settings
export default function site_config() {
  Vue.component('loader', Loader)
  Vue.mixin(Mixins)
  SentryInit()
  router.beforeEach((to, from, next) => {
    let app_routes = []
    app_routes = [
      ...routes.prod,
      ...routes.dev,
    ]
    let current_route = app_routes.filter(r => {
      return r.path == to.path
    })
    if (current_route.length == 0) {
      window.console.log('[@travelc/main.js] - beforeEach() - forced router push')
      //router.push({ name: 'not-found' })
      //return
    }
    next()
    return
  })
}